import { render, staticRenderFns } from "./UserSearchModal.vue?vue&type=template&id=49f5ddb8"
import script from "./UserSearchModal.vue?vue&type=script&lang=js"
export * from "./UserSearchModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports